import { useState, useEffect, useContext } from "react";
import SignalementServices from "../services/signalementServices";
import { AuthContext } from "../contexts/AuthContext";

function useSignalement() {
  const { api } = useContext(AuthContext);
  const service = new SignalementServices(api);

  const fetchSignalements = () => {
    return service.getAll();
  };

  const getOneSignalement = (articleId, articleSignaleur=null) => {
    return service.getOne(articleId, articleSignaleur);
  };

  const createSignalement = (data) => {
    return service.create(data);
  };

  const deleteSignalement = (id) => {
    return service.delete(id);
  };

  const updateSignalement = (id, data) => {
    return service.update(id, data);
  };

  const signalementRecap = (id) => {
    return service.signalementRecap(id);
  };

  const validateSignalement = (id) => service.validate(id);
  const rejectSignalement = (id) => service.reject(id);

  return {
    fetchSignalements,
    createSignalement,
    deleteSignalement,
    getOneSignalement,
    updateSignalement,
    signalementRecap,
    validateSignalement,
    rejectSignalement,
  };
}

export default useSignalement;
